import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ✅ Load Market Insights
export async function loadMarketInsightsApi(user_id) {
  try {
    const fd = new FormData();

    fd.append("user_id", user_id);

    const res = await axios.post(
      `${apiBaseUrl}agencyinsightapis/market_insights`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch {
    return { status: false };
  }
}
